(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RfGlobalShortDayDateFilter', [RfGlobalShortDateFilterFn]);
    
    function RfGlobalShortDateFilterFn() {
        return function (date) {
            if (date) {
                var dateMoment = moment(date);
                return dateMoment.format('dd L');
            }
            return date;
        };
    }
})();